import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpedia = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.14661 2H17.8535C20.1507 2 22.0001 3.84939 22.0001 6.14661V17.8534C22.0001 20.1506 20.1507 22 17.8535 22H6.14661C3.84939 22 2 20.1506 2 17.8534V6.14661C2 3.84939 3.84939 2 6.14661 2Z",
			fill: "#FDDB32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.59248 5.58072C7.40611 5.58073 7.28898 5.62355 7.19028 5.72224L5.19176 7.72077C5.15465 7.75787 5.1338 7.80825 5.13379 7.86073C5.13378 7.96998 5.22238 8.05857 5.33164 8.05857H13.9953L8.66912 13.3847C8.56415 13.4897 8.50309 13.5507 8.5031 13.7567L8.50309 15.1581C8.50309 15.2429 8.5417 15.3165 8.59708 15.3719C8.65247 15.4273 8.72594 15.4658 8.8108 15.4658H10.2123C10.4182 15.4658 10.4792 15.4048 10.5842 15.2998L15.9104 9.97363V18.6373C15.9104 18.7466 15.999 18.8352 16.1082 18.8352C16.1607 18.8352 16.2111 18.8143 16.2482 18.7772L18.2467 16.7787C18.3454 16.68 18.3883 16.5629 18.3882 16.3765L18.3882 6.91622C18.3882 6.74084 18.3537 6.56717 18.2866 6.40514C18.2194 6.2431 18.1211 6.09588 17.997 5.97186C17.873 5.84785 17.7258 5.74948 17.5638 5.68237C17.4017 5.61525 17.228 5.58071 17.0527 5.58072L7.59248 5.58072Z",
			fill: "#191E3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.89573 15.8552H7.81811C7.97891 15.8552 8.10837 15.9847 8.10837 16.1455V18.0799C8.10837 18.2407 7.97891 18.3702 7.81811 18.3702H5.89573C5.73493 18.3702 5.60547 18.2407 5.60547 18.0799V16.1455C5.60547 15.9847 5.73493 15.8552 5.89573 15.8552Z",
			fill: "#191E3B"
		})
	]
});
const ForwardRef = forwardRef(SvgExpedia);
export { ForwardRef as ReactComponent };
